import BondPrincipalAttorneySearchSection from "./BondPrincipalAttorneySearchSection";
import SelectedAttorneySummary from "./SelectedAttorneySummary";
import {
  buildBondPrincipalAttorneySearchSectionProps,
  handleGuardianshipAttorneySelection,
} from "../utils/bondGuardianAttorneyWiring";

export { buildGuardianshipAttorneyFormContext } from "../utils/bondGuardianAttorneyWiring";

export function GuardianshipAttorneySearchSection({
  apiClient,
  role,
  lawfirmId,
  toast,
  updateData,
  data,
  guardians,
  guardian,
  guardianIndex,
  fieldError,
  renderAfterSummary,
}) {
  return (
    <BondPrincipalAttorneySearchSection
      {...buildBondPrincipalAttorneySearchSectionProps({
        apiClient,
        role,
        lawfirmId,
        toast,
        updateData,
        data,
        guardians,
        guardian,
        guardianIndex,
        selectionHandler: handleGuardianshipAttorneySelection,
        fieldError,
        required: true,
      })}
    >
      {(attorneys) => (
        <>
          <SelectedAttorneySummary
            attorneys={attorneys}
            guardian={guardian}
            title="Selected Attorney Details:"
            addressLabel="Office Address"
          />
          {renderAfterSummary ? renderAfterSummary({ attorneys }) : null}
        </>
      )}
    </BondPrincipalAttorneySearchSection>
  );
}

export function renderGuardianshipAttorneyBranch(
  formContext,
  guardian,
  guardianIndex,
  renderAfterSummary
) {
  return (
    <GuardianshipAttorneySearchSection
      {...formContext}
      guardian={guardian}
      guardianIndex={guardianIndex}
      renderAfterSummary={renderAfterSummary}
    />
  );
}

export default GuardianshipAttorneySearchSection;
